module.exports = __webpack_public_path__ + "media/application/images/ico-white-8c1790bb734bf0d2ef7615d25c5a6d74.png";